import { produce } from 'immer';
import { memoize } from 'lodash-es';
import { Theme } from 'theme';

export const pdfModalTheme: (globalTheme: Theme) => Theme = memoize(
  (globalTheme) =>
    produce(globalTheme, (draft) => {
      draft.modal.content.tablet.bottom = '0';
      draft.modal.content.mobile.bottom = '0';
      draft.modal.content.tablet.top = '0';
      draft.modal.content.mobile.top = '0';

      draft.modal.content.tablet.width = '100%';
      draft.modal.content.mobile.width = '100%';
      draft.modal.scrollableWrapper.mobile.maxHeight = `calc(${window.innerHeight}px - 50px)`;
      draft.modal.scrollableWrapper.tablet.maxHeight = `calc(${window.innerHeight}px - 50px)`;
    }),
);
